import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';



@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule]
})
export class ExcoModule {
  static forRoot(config): ModuleWithProviders<ExcoModule> {
    return {
        ngModule: ExcoModule,
        providers: [],
    };
}
}
